<template>
  <div>
    <div v-for="(table, index) in formattedTables" :key="index" class="card">
      <div class="card-header">
        <h2>{{ table.tableName }}</h2>
      </div>

      <div class="card-table">
       <customTable :headers="table.headers" :items="table.data">
  <template v-for="header in table.headers" v-slot:[`item.${header.value}`]="{ value }">
    <scraped-value-display :key="header.value" :value="String(value)" />
  </template>
</customTable>
      </div>
    </div>
  </div>
</template>
<script>
import customTable from './customTable.vue'
import scrapedValueDisplay from '@/components/commonComponents/scrappedValueDisplay.vue'

export default {
  name: 'AdditionalTables',
  components: {
    customTable,
    scrapedValueDisplay
  },
  props: {
    tables: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      formattedTables: []
    }
  },
  methods: {
    formatTableData (rawTable) {
      if (!rawTable || !Array.isArray(rawTable.data)) return null

      const headers = rawTable.headers.map((header, index) => ({
        text: header,
        value: `col${index + 1}`
      }))

      const data = rawTable.data.map((row) => {
        const obj = {}
        headers.forEach((header, i) => {
          obj[header.value] = row[i] != null ? row[i] : ''
        })
        return obj
      })

      return {
        tableName: rawTable.table_name,
        sourceTab: rawTable.source_tab,
        headers,
        data
      }
    },
    formatTablesData (tables) {
      this.formattedTables = tables.map(this.formatTableData)
    }
  },
  mounted () {
    this.formatTablesData(this.tables)
  },
  watch: {
    tables: {
      handler (newTables) {
        this.formatTablesData(newTables)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.card {
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 12px;
  margin-bottom: 12px;
}

.card-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.card-table {
  margin-top: 12px;
  overflow-x: auto;
}
</style>
